/**
 * Русское склонение по числу: 1 продукт, 2 продукта, 5 продуктов.
 * Нужно там, где иначе пришлось бы перечислять полтора десятка названий.
 */
export const plural = (
  count: number,
  one: string,
  few: string,
  many: string
) => {
  const mod100 = Math.abs(count) % 100
  if (mod100 >= 11 && mod100 <= 14) return many
  switch (mod100 % 10) {
    case 1:
      return one
    case 2:
    case 3:
    case 4:
      return few
    default:
      return many
  }
}
